import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { ApiResponseService } from 'src/app/services/api-response.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-marketing-banner',
  templateUrl: './marketing-banner.component.html',
  styleUrls: ['./marketing-banner.component.scss'],
})
export class MarketingBannerComponent implements OnInit {
  bannerText: string = '';

  @Output() bannerInitialized = new EventEmitter<void>();
  @Output() bannerClosed = new EventEmitter<void>();

  constructor(private apiService: ApiResponseService, public global: GlobalService ) {}

  ngOnInit(): void {
  this.apiService.getMarketingBanner().subscribe({
    next: (bannerConfig) => {
      const bannerValue = bannerConfig?.data?.[0]?.value?.trim();

      if (!bannerValue) {
        this.bannerClosed.emit();
        return;
      }

      if (bannerValue.includes('$X')) {
        // stats to replace the placeholder
        this.apiService.getMarketingStats().subscribe({
          next: (stats) => {
            const amount = stats.data?.last12MonthAmountCharged;

            if (amount !== undefined && amount !== null) {
              if (amount >= 10) {
                // replaces $X
                this.bannerText = bannerValue.replace('$X', `$${amount}`);
                this.bannerInitialized.emit();
              } else {
                // fallback text
                this.bannerText =
                  '53% of growing managers on TenantPay are already collecting rent for free. Want in? ';
                  this.bannerInitialized.emit();
              }
            } else {
              this.bannerClosed.emit();
            }
          },
          error: () => this.bannerClosed.emit(),
        });
      } else {
        // No placeholder → show as-is
        this.bannerText = bannerValue;
        this.bannerInitialized.emit();
      }
    },
    error: () => this.bannerClosed.emit(),
  });
}



  get isBannerVisible(): boolean {
    return this.bannerText.trim().length > 0;
  }

  dismiss(): void {
    this.bannerClosed.emit();
  }

  openYardiLink(): void {
  const url = this.global.loggedInUser?.yardiCompany
    ? 'https://www.tenantpay.com/no-fee-rent?utm_source=LL-banner&utm_campaign=October'
    : 'https://www.tenantpay.com/free-rent-collection?utm_source=LL-banner&utm_campaign=October';

  window.open(url, '_blank');
}

}
